
const initialState = {
  data: [],
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  sortIndex: [],
  sweet:null,
  res:null,
  currentSale:false,
  showForm:false,
  sweetInfoDelete:false,
  listClients:[],
  listVehicles:[],
  listMaterials:[],
  listMachineries:[],
  listContracts:[],
  listMaterialTaxes:[],
  listPaymentMethods:[],
  listCellars:[],
  listPrepaidSalesByClient:[],
  listBankAccounts:[],
  dataLoading:{},
}

const SalesReducer = (state = initialState, action) => {
  
  switch (action.type) {

    case "SHOW_SALE_LOADING":
      const dataLoading = state.dataLoading;
      dataLoading[action.index] = action.data;
      return {
        ...state,
        dataLoading: dataLoading
      }

    case "HIDE_SALE_LOADING":
        delete state.dataLoading[action.index];
        return {
          ...state,
        }
    
    case "GET_SALES_DATA":
      return {
        ...state,
        data: action.data.data,
        totalPages: action.totalPages,
        params: action.params,
        sortIndex: [action.data.from,action.data.to]
      }

    case "GET_SALES_ALL_DATA":
      return {
        ...state,
        allData: action.data.data,
        totalRecords: action.data.total,
        sortIndex: [action.data.from,action.data.to],
        showForm:false,
        currentSale:false
      }

      case "GET_SALE_CLIENTS_ALL":
        return {
          ...state,
          listClients: action.data
        }

        case "GET_SALE_BANK_ACCOUNTS_ALL":
          return {
            ...state,
            listBankAccounts: action.data
          }

      case "GET_SALE_MATERIAL_TAXES_ALL":
        return {
          ...state,
          listMaterialTaxes: action.data.rates
        }
      
      case "GET_SALE_VEHICLES_ALL":
        return {
          ...state,
          listVehicles: action.data
        }


      case "GET_SALE_CELLARS_ALL":
          return {
            ...state,
            listCellars: action.data
          }

      case "GET_SALE_PAYMENT_TYPES_ALL":
        return {
          ...state,
          listPaymentMethods: action.data
        }

      


        
      
      case "GET_SALE_MATERIALS_ALL":
        return {
          ...state,
          listMaterials: action.data
        }
      
      case "GET_SALE_MACHINERIES_ALL":
        return {
          ...state,
          listMachineries: action.data
        }

      case "GET_SALE_CONTRACTS_ALL":
        return {
          ...state,
          listContracts: action.data
        }

      case "GET_SALE_PREPAID_SALES_BY_CLIENTS_ALL":
        return {
          ...state,
          listPrepaidSalesByClient: action.data,
        }
    

    case "INIT_FORM_SALE":
      return {
        ...state,
        res:action.res,
        showForm:action.showForm,
        sweetInfoDelete:false,
      }

    case "SHOW_SALE":
      return {...state,
        currentSale:{...action.res.data},
        showForm:action.showForm,
        sweetInfoDelete:false,
      }
    
    case "ERROR_GET_SALE":
      return {...state,...action}
    
    case "ERROR_DELETE_SALE":
      return {
        ...state,
        sweetInfoDelete:{...action.sweet}
      }

    case "SAVED_SALE":
      return {
        ...state,
        sweet:{ ...action.sweet}
      }

    case "ERROR_SAVED_SALE":
      return {
        ...state,
        sweet:{ ...action.sweet}
      }

    case "SHOW_SWHEET_SALE":
      return {
        ...state,
        sweet:{ ...action.sweet}
      }

    case "HIDE_SWHEET_SALE":
      return {
        ...state,
        sweet:null
      }
      
    case "HIDE_SWEET_SALE":
      return {
        ...state,
        sweet:null,
        sweetInfoDelete:false,
      }

    case "CLEAN_SALE_CONTRACT_LIST":
      return {
        ...state,
        sweet:null,
        listClients:[{}],
        listVehicles:[{}],
        listMaterials:[{}],
        listPrepaidSalesByClient:[{}],
        
      }

    case "CLEAN_CONTRACT_LOADING":
      return {
        ...state,
        dataLoading:{}
      }
    
    default:
      return state
  }
}

export default SalesReducer